<template>
    <section class="relative flex flex-wrap gap-4 lg:gap-6">
        <template v-for="(component, index) in components" :key="`${component.alias}-${index}`">
            <component
                :is="mapComponentAlias(component.alias ?? '')"
                v-bind="component"
                :class="[
                    index === 0 ? 'lg:w-[calc(33.3333%-12px)]' : 'lg:w-[calc(66.6666%-12px)]',
                    'w-full',
                    component.alias === 'imageItem' && index === 1
                        ? 'right-0 max-h-25.5 lg:absolute lg:max-h-full'
                        : 'left-0',
                ]" />
        </template>
    </section>
</template>
<script lang="ts" setup>
import type { FourtySixtyComponentModel } from '@su4r-frontend/api';

const { components } = defineProps<FourtySixtyComponentModel>();
</script>
